import { ReactElement } from 'react';

import { Flex, Section, Typography } from 'components';

import { DashboardButtonMore, DashboardVisualizationTypeEnum, NextSheet, SchoolDashboardArea, useSheets } from 'features/dashboard-new';

import Cards from '../cards';

interface SheetGridProps {
  area: SchoolDashboardArea;
  dashboardVisualizationType: DashboardVisualizationTypeEnum;
  nextSheetUuid?: string;
}

const SheetGrid = ({ area, dashboardVisualizationType, nextSheetUuid }: SheetGridProps): ReactElement => {
  const { sheetTheme } = useSheets();

  const theme = sheetTheme(dashboardVisualizationType, area.dashboardAreaColor);

  return (
    <>
      <Flex id={`dashboard-area-${area.uuid}`} className="dashboard-area" flexGrow={0} bg={theme.sheetBg} py={{ m: 30, d: 100 }}>
        <Section flexDirection="column" flexGrow={0}>
          <Flex mb={5} alignItems="center" justifyContent="space-between">
            <Flex flexDirection="column">
              {!!area.hat && (
                <Typography type="type3" upper mb={1} color={theme.titleColor}>
                  {area.hat}
                </Typography>
              )}

              <Typography as="h2" type="type8" fontWeight="bold" color={theme.titleColor}>
                {area.name}
              </Typography>
            </Flex>

            <Flex alignItems="center" flexGrow={0}>
              <DashboardButtonMore area={area} />
            </Flex>
          </Flex>

          <Cards cards={area?.cards} dashboardAreaColor={area.dashboardAreaColor} dashboardVisualizationType={dashboardVisualizationType} />
        </Section>
      </Flex>

      <NextSheet nextSheetUuid={nextSheetUuid} dashboardAreaColor={area.dashboardAreaColor} dashboardVisualizationType={dashboardVisualizationType} />
    </>
  );
};

export default SheetGrid;
